<template>
<div id="reporte_saldos_fracciones" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Selección de fechas de aplicación para generar los Saldos por Fracción
" class="elevation-1 px-5 py-3" >
            <span style="color:red;">*Estimado Usuario: la selección de fechas que a continuación se deben ingresar, NO se refieren a un rango de periodo. Los valores requeridos se refieren a la fecha de "Cargo" de las IMPORTACIONES que se busca valorar desde el inicio de su registro como empresa Certificada IVA & IEPS, así como los "Abonos" reportados a la fecha de transmisión del informe de descargos al SCCCyG.</span>
          <br>

              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col cols="12" sm="6" md="6" lg="6" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_cargo" label="Fecha De Cargo" color="secondary" prepend-icon="event" @blur="model.fecha_cargo = parseDate(model.fecha_cargo)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_cargo" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" >
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_abono" label="Fecha de Abono" color="secondary" prepend-icon="event" @blur="model.fecha_abono= parseDate(model.fecha_abono)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaFecha]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_abono" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>  
                      <v-row >
                            <v-col cols="12" md="3" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                <v-autocomplete v-model="model.activo" :items="list_activos" :hide-no-data="true" 
                                    item-text="text" item-value="id"
                                    :return-object="false"  label="Activo Fijo" >
                                </v-autocomplete>
                            </v-col>                      
                            <v-col cols="12" md="3" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                <v-autocomplete v-model="model.opcion_reporte" :items="reportes_arr" 
                                    :hide-no-data="true" item-text="val" item-value="id"
                                    label="Reporte">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="2" sm="2" lg="2" style="text-align:right !important;">
                              <v-btn color="info" @click="generar_reporte_sqs" >
                                  <v-icon>search</v-icon>Generar
                                </v-btn>                                
                            </v-col>
                            <v-col cols="12" md="2" sm="2" lg="2" style="text-align:left !important;">
                                <exportar-excel v-if="datos.reportes.length > 0" :data="datafiltered" :exportFields="campos_exportar" 
                                  :name="'Saldos_por_fracciones_'+getTipo(model.opcion_reporte)+'.xlsx'">
                                  <v-btn light color="green" title="Exportar a Excel" v-tippy>
                                      <v-icon dark>mdi-table</v-icon> Excel
                                  </v-btn>
                              </exportar-excel>
                            </v-col>
                      </v-row>                    
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  
                  
                    <v-row dense style="text-align:center !important;" v-if="datos.reportes.length > 0">
                      <v-col sm="12" lg="12" md="12">
                        <v-row dense>
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong>Cargos</strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong>Abonos</strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong>Saldo</strong>
                          </v-col>
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>
                        </v-row>
                        <v-row dense>   
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>                    
                          <v-col lg="2" md="2" sm="2">
                            <strong>${{formatNumberDec(totalCargos,2)}}</strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong><span style="color:green">${{formatNumberDec(totalAbonos,2)}}</span></strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong><span style="color:maroon">${{formatNumberDec(totalSaldo,2)}}</span></strong>
                          </v-col>
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>
                        </v-row>
                      </v-col>                    
                    </v-row>
                  
                  
                </v-card-actions>
                <v-card-text v-if="cliente!='' && domicilio!='' && datos.reportes.length > 0">                  
                  <div style="text-align:right !important;">Fecha de Consulta: {{ fecha_actual }}</div>
                  {{cliente.nombre}} - {{cliente.identificador}} 
                  <br>
                  C. {{domicilio.domicilio.toUpperCase()}}, Col. {{domicilio.colonia.toUpperCase()}}
                  C.P. {{domicilio.codigo_postal}}, {{domicilio.estado_nombre.toString().toUpperCase()}},
                  {{domicilio.pais.clave_m3.toString().toUpperCase()}}<br><br>

                  <div style="text-align:center !important;">
                  <strong>Servicio de consulta de movimientos en el SCCCyG / Saldos Fracciones / SoluciónA31</strong>
                  <br>
	                Fecha de aplicación de Cargos: {{model.fecha_cargo}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                  Fecha de aplicación de Abonos: {{model.fecha_abono}} 	
                  </div>
                  
                </v-card-text>
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="FRACCION ARANCELARIA" slot-scope="props">
                      <div style="text-align:center">{{ props.row["FRACCION ARANCELARIA"] }}</div>
                    </template>

                    <template slot="ACTIVO FIJO" slot-scope="props">
                      <div style="text-align:center">{{ props.row["ACTIVO FIJO"] }}</div>
                    </template>

                    <template slot="INVENTARIO INICIAL" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(parseFloat(props.row["INVENTARIO INICIAL"]).toFixed(2),2) }}</div>
                    </template>

                    <template slot="ENTRADAS" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(parseFloat(props.row["ENTRADAS"]).toFixed(2),2) }}</div>
                    </template>

                    <template slot="TOTAL CARGOS" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(parseFloat(props.row["TOTAL CARGOS"]).toFixed(2),2) }}</div>
                    </template>

                    <template slot="TOTAL ABONOS" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(parseFloat(props.row["TOTAL ABONOS"]).toFixed(2),2) }}</div>
                    </template>

                    <template slot="SALDO" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(parseFloat(props.row["SALDO"]).toFixed(2),2) }}</div>
                    </template>
                    
                  </v-client-table>
                </v-card-text>
              </div>

        </base-material-card>
      </v-col>
    </v-row>
    <LoaderFraces ref="estadoLoader" :mensajes="lista_mensajes" ></LoaderFraces>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
import LoaderFraces from "@/components/LoaderFraces";

export default {
  components: {
    "v-refresh-button": RefreshButton,
    LoaderFraces,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }    
    this.loading = false;    
    this.tipo = 1;
    this.fecha_actual = moment().format('YYYY-MM-DD');
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario"); 
    this.getCliente();  
    this.cargarPaises();
    this.cargarDomicilio(); 
  },
  computed: {    
        datafiltered() {

            let result = [];
            if (this.$refs.vuetable != null) {
               result = this.$refs.vuetable.allFilteredData;
                return result;
            } else {
               result = this.datos.reportes;
                return result;
            }
    },
  },
  data: () => ({
    lista_mensajes: [
            "AGRADECEMOS SU PACIENCIA..",
            "ESTAMOS PROCESANDO LOS CARGOS..",
            "VERIFICANDO IDENTIFICADORES..", 
            "VALIDACIÓN DE FORMAS DE PAGO..", 
            "PROCESANDO ABONOS A LA FECHA..", 
            "VERIFICANDO FRACCIONES..",
            "VALIDANDO CUENTAS POR IDENTIFICADOR DE ACTIVO..",  
            "ANALIZANDO SOBREDESCARGO..", 
            "GESTIONANDO SALDOS POR FRACCIÓN..", 
            "TOTALIZANDO VALOR COMERCIAL PENDIENTE DE RETORNO..", 
            "TOTALIZANDO CRÉDITO FISCAL.."
        ],
    fecha_actual:"",
    domicilio:"",
    cliente:"",
    paises:[],
    estados:[],
    totalCargos:0,
    totalAbonos:0,
    totalSaldo:0,
    permisoEliminar:false,
    list_activos:[
        {"id":"N","text":"No"}, //No Activo Fijos
        {"id":"S","text":"Si"}, //Activo Fijo
        {"id":"","text":"Todos"}],
    fracciones: [],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Reportes",
        disabled: true,
        to: ""
      },
      {
        text: "Saldos por Fracción",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      reportes: [],
      exportar: [],      
    },
    campos_exportar:{
        "Fracción Arancelaria":"FRACCION ARANCELARIA", 
        "Activo Fijo":"ACTIVO FIJO", 
        "Inventario Inicial":"INVENTARIO INICIAL", 
        "Entradas":"ENTRADAS", 
        "Total Cargos":"TOTAL CARGOS", 
        "Total Abonos":"TOTAL ABONOS", 
        "Saldo":"SALDO"
    },
    
    columns_reportes: ["FRACCION ARANCELARIA", "ACTIVO FIJO", "INVENTARIO INICIAL", "ENTRADAS", 
        "TOTAL CARGOS", "TOTAL ABONOS", "SALDO"],
    options_reportes: {
        filterable: true,
        filterByColumn: false,
        texts: {
            filter: '',
            filterPlaceholder: 'Buscar',
        },
        orderBy: {
            column: 'FRACCION ARANCELARIA',
            ascending: true
        },       

      headings: {
        "FRACCION ARANCELARIA":"Fracción Arancelaria", 
        "ACTIVO FIJO":"Activo Fijo", 
        "INVENTARIO INICIAL":"Inventario Inicial", 
        "ENTRADAS":"Entradas", 
        "TOTAL CARGOS":"Total Cargos", 
        "TOTAL ABONOS":"Total Abonos", 
        "SALDO":"Saldo"
      }
    },
    loading: false,
    show_loading: true,
    list_reportes: [
            {
                "reporte": "Pref. Arancelarias Activo Fijo WS",
                "url": "/reportes_ws/partidas_activo_fijo/"
            },
            {
                "reporte": "Pref. Arancelarias Activo Fijo DS",
                "url": "/reportes_ds/partidas_activo_fijo_ds/"
            },            
    ],
    reportes_arr:[
        {id:1, val: "Completo"},
        {id:2, val: "Inventario Inicial"},
        {id:3, val: "Cargos"},
        {id:4, val: "Sobredescargos"},
    ],
    model: {
      rfc: "",
      usuario: "",
      fecha_cargo: "",
      fecha_abono: "",
      activo: "N",
      opcion_reporte: 1,
      reporte_url: "/soluciona31/reportes/rpt_saldos_fracciones/",
      nombre_reporte: "Saldos Por Fracción",
      tipo: "SA31_Saldos_Fracciones",      
    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,

  }),
  methods: {
    cargarPaises: function () {
        axios
            .get(this.$hostname + "paises/")
            .then(res => {
                if (typeof res.data !== "undefined") this.paises = res.data;
                else {
                    this.$swal({
                        type: "warning",
                        title: "Aviso",
                        text: "No se han ingresado datos al catálogo de países",
                        footer: ""
                    });
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener el catálogo de países.",
                    footer: ""
                });
                console.log(err);
            });
    },

    cargarPaisSeleccionado: function (id_pais) {
        axios
            .get(this.$hostname + "paises/" + id_pais + "/")
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.domicilio.pais = res.data;                    
                } else {
                    this.$swal({
                        type: "warning",
                        title: "Aviso",
                        text: "No se encontró el país guardado en el domicilio",
                        footer: ""
                    });
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener el país del domiclio.",
                    footer: ""
                });
                console.log(err);
            });
    },

    cargarDomicilio: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var datos = {
            cliente: this.$local_storage.get("id_cliente")
        };
        axios
            .post(this.$hostname + "datos-clientes/get_domicilio_cliente/", datos)
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.domicilio = res.data;
                    this.cargarPaisSeleccionado(res.data.pais);
                    this.update = true; //Significa, que ya tiene datos y hay que actualizarlos
                }
            })
            .catch(err => {
                if (typeof err.response.data.mensaje == "undefined") {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los datos de la organización.",
                        footer: ""
                    });
                    console.log(err);
                }
            }).then(()=>{
                this.$root.$dialogLoader.hide();
            });
    },
    getCliente: function () {                        
        let id = this.$local_storage.get("id_cliente");
        axios
            .get(this.$hostname + "clientes/" + id + "/")                
            .then(response => {
                this.cliente = response.data;                
            })
            .catch(error => {                    
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener el cliente",
                    footer: ""
                });
            });
    },
    
    getTipo:function(opcion){
        var filtro = this.reportes_arr.find(e => e.id == opcion)
        if (filtro){
            return filtro.val;
        } else {
            return "";
        }
    },
    validaMes: function() {
        if (this.model.fecha_cargo != null && this.model.fecha_abono != null && this.model.fecha_cargo != "" && this.model.fecha_abono != "") {
            var inicio = moment(this.model.fecha_cargo, "YYYY-MM-DD");
            var fin = moment(this.model.fecha_abono, "YYYY-MM-DD");
            var diferencia = fin.diff(inicio, 'days')
            if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            if (Math.abs(diferencia) > 31)
                return "Periodo máximo de consulta 31 días. Favor de verificar.";
        }
        return true;
    },
    setNombreReporte: function () {
        var url = this.model.reporte_url
        var search = this.list_reportes.filter(function (e) {
            return e.url == url;
        });
        if (search.length > 0) {
            this.model.nombre_reporte = search[0].reporte;
        }
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_cargo != "" && this.model.fecha_abono != "") {
        var inicio = moment(this.model.fecha_cargo, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_abono, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    getFracciones:function(){
       this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = {
            "identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.fracciones = response.data
                } else {
                    this.fracciones = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
              footer: ""
            });
          }).then(() => {            
            this.$root.$dialogLoader.hide();
          }); 
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    formatNumberDec: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return "";
            numero = Number(numero);
            if (isNaN(numero)){
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
    formatNumber: function (x) {
      if (x == undefined) return 0;
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },
    generar_reporte_sqs() {
        
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {                 
        this.$refs.estadoLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        this.totalCargos = 0;
        this.totalAbonos = 0;
        this.totalSaldo = 0;
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/rpt_saldos_fracciones/",
            //url: "http://127.0.0.1:7000/soluciona31/reportes/rpt_saldos_fracciones/",
            data: data
          })
          .then(response => {
            if (response.data != undefined && response.data.length) {
                this.datos.reportes = response.data;                
                for(var k in this.datos.reportes){
                    var e = this.datos.reportes[k];
                    e["INVENTARIO INICIAL"] = parseFloat(parseFloat(e["INVENTARIO INICIAL"]).toFixed(2));
                    e["ENTRADAS"] = parseFloat(parseFloat(e["ENTRADAS"]).toFixed(2));
                    e["TOTAL CARGOS"] = parseFloat(parseFloat(e["TOTAL CARGOS"]).toFixed(2));
                    e["TOTAL ABONOS"] = parseFloat(parseFloat(e["TOTAL ABONOS"]).toFixed(2));
                    e["SALDO"] = parseFloat(parseFloat(e["SALDO"]).toFixed(2)); 
                    this.totalCargos +=  e["TOTAL CARGOS"];
                    this.totalAbonos += e["TOTAL ABONOS"];
                }
                this.totalSaldo = (this.totalCargos - this.totalAbonos).toFixed(2);
            } else {                
                this.datos.reportes = [];
                this.$swal({
                  type: "info",
                  title: "No se encontró información.",
                  text: "Con los criterios seleccionados. Favor de verificar.",
                  footer: ""
                });
            }
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
            this.$refs.estadoLoader.hide();
          }).then(() => {            
            this.$refs.estadoLoader.hide();
          });
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "SA31_Saldos_Fracciones"
      };
      axios.post(this.$apiSA31+ "soluciona31/reportes/get_reportes/", data)      
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          return "Fecha Cargo: " + params.fecha_cargo + ", " + "Fecha Abono: " + params.fecha_abono;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)          
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();                         
            });
        }
      });
    },
  },
};
</script>
<style scoped>
    .class-center {
        text-align: center !important;
    }
    .class-right {
        text-align: right !important;
    }
</style>
